import type { Location } from "history";
import { createContext, useContext } from "react";

export enum NavigationDirection {
  New,
  Forward,
  Replace,
  Back,
}

export type PreviousLocation = Readonly<{
  location?: Location;
  direction: NavigationDirection;
}>;

export const LocationTrackerContext = createContext<PreviousLocation>({
  direction: NavigationDirection.New,
});

export const usePreviousLocation = () => useContext(LocationTrackerContext);
